import { changeTabs, showFullExcerpt } from "../sections/products";
import { slickCarousel } from "../sections/slides";
import { faq } from "../sections/faq";
import { doSubscribe } from "../sections/subscribe";
import { showStickyHeader } from "../sections/menu";

export default {
  init() {
    // JavaScript to be fired on all pages
    slickCarousel();

    changeTabs();

    faq();

    doSubscribe();

    showFullExcerpt();

    showStickyHeader();

    // show and hide mobile nav on mobile
    const openMobileNav = document.querySelector("#openMobileNav");
    const closeMobileNav = document.querySelector("#closeMobileNav");
    const mobileNavMenu = document.querySelector("#mobileNavMenu");

    if (openMobileNav && mobileNavMenu && closeMobileNav) {
      // remove hidden class
      openMobileNav.addEventListener("click", () => {
        mobileNavMenu.classList.remove("hidden");
      });

      // add hidden class
      closeMobileNav.addEventListener("click", () => {
        mobileNavMenu.classList.add("hidden");
      });
    }

    // add and remove sticky nav
    const mimHeaderMobile = document.querySelector("#mimHeaderMobile");
    const mimHeaderDesktop = document.getElementById("mimHeaderDesktop");
    _showStickyHeader({
      mobileSelectop: mimHeaderMobile,
      desktopSelector: mimHeaderDesktop,
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};

// function _hasMenu(element, classname) {
//   return element.classList.contains(classname) ? true : false;
// }

function _showStickyHeader({ mobileSelector, desktopSelector }) {
  if (!mobileSelector || !desktopSelector) return;
  console.log(mobileSelector, desktopSelector);
}



// WEBPACK FOOTER //
// ./scripts/routes/common.js